import * as React from 'react'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  withStyles,
  createStyles,
  Theme,
  WithStyles
} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import { RootState } from 'src/core/redux/reducer'
import Btn from 'src/shared/Btn/Btn'
import { ModalAction } from 'src/core/redux/action/modalActions'
import { ModalType } from 'src/type/modal'

const styles = (t: Theme) => createStyles({
    center: {
        justifyContent: 'center'
    },
    left: {
        justifyContent: 'flex-start'
    },
    right: {
        justifyContent: 'flex-end'
    },
});

interface IProps extends WithI18n, 
    WithStyles<typeof styles>,
    ReturnType<typeof state2props>,
    ReturnType<typeof dispatch2props> {
}

class ReduxModal extends React.Component<IProps, any> {

    render() {
        const {
            t, classes, type, title, contentText, isOpen, isLoading, onSubmit, content, maxWidth, fullScreen, 
            isValid, confirmLabel, cancelLabel, onClose, onCloseDefault, actionPosition
        } = this.props;
        return(
            <Dialog
                disableEnforceFocus
                open={isOpen}
                onClose={!!onClose ? onClose : onCloseDefault}
                maxWidth={maxWidth || "sm"}
                fullWidth={fullScreen}
            >
                {title &&
                    <DialogTitle style={{paddingBottom: '10px'}}>{title}</DialogTitle>
                }
                {contentText &&
                    <DialogContentText style={{paddingBottom: '10px'}}>{contentText}</DialogContentText>
                }
                <DialogContent>
                    {content}
                </DialogContent>

                <DialogActions className={classes[actionPosition]}>
                    {[ModalType.CONFIRMATION, ModalType.FORM].includes(type) && 
                        <>
                            <Btn
                                color="primary"
                                onClick={!!onClose ? onClose : onCloseDefault}
                            >
                                {cancelLabel ? cancelLabel : t.cancel}
                            </Btn>
                            <Btn
                                loading={isLoading}
                                onClick={onSubmit}
                                color="primary"
                                variant="raised"
                                {...type === ModalType.FORM && {disabled: isValid || false}}
                            >
                                {confirmLabel ? confirmLabel : t.confirm}
                            </Btn>
                        </>
                    }
                    
                    {[ModalType.CUSTOM, ModalType.REVIEW].includes(type) && 
                        <>
                            <Btn
                                color="primary"
                                onClick={!!onClose ? onClose : onCloseDefault}
                            >
                                {cancelLabel ? cancelLabel : t.cancel}
                            </Btn>
                        </>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

const state2props = (state: RootState) => ({
    type: state.modal.type,
    title: state.modal.title,
    contentText: state.modal.contentText,
    isOpen: state.modal.isOpen,
    isLoading: state.modal.isLoading,
    onClose: state.modal.onClose,
    onSubmit: state.modal.onSubmit,
    content: state.modal.content,
    maxWidth: state.modal.maxWidth,
    fullScreen: state.modal.fullScreen,
    isValid: state.modal.isValid,
    callback: state.modal.callback,
    cancelLabel: state.modal.cancelLabel,
    confirmLabel: state.modal.confirmLabel,
    actionPosition: state.modal.actionPosition,
});

const dispatch2props = (dispatch: any, ownProps: any) => ({
    onCloseDefault: () => dispatch(ModalAction.closeModal()),
})

export default compose(
    withI18n,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(ReduxModal)



// WEBPACK FOOTER //
// ./src/shared/Modal/ReduxModal.tsx